var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"row-cards"},_vm._l((_vm.tabs),function(tab,key){return _c('StatsCards',_vm._b({key:key,staticStyle:{"cursor":"pointer"},nativeOn:{"click":function($event){return _vm.selectTab(key)}}},'StatsCards',tab,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }